<i *ngFor="let star of getReviewStars()" [ngClass]="star">
</i>